import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { CurrencyProvider } from "./contexts/CurrencyContext";
import { AuthProvider } from "./contexts/AuthContext";
import { PublicSite } from "./components/PublicSite";
import { AdminLayout } from "./components/admin/AdminLayout";
import { ProtectedRoute } from "./components/admin/ProtectedRoute";

import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminTestimonialsPage from "./pages/admin/AdminTestimonialsPage";
import AdminBlogPage from "./pages/admin/AdminBlogPage";
import AdminBlogEditorPage from "./pages/admin/AdminBlogEditorPage";
import AdminLeadsPage from "./pages/admin/AdminLeadsPage";

function App() {
  return (
    <CurrencyProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Admin (no public nav/footer) */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboardPage />} />
                <Route path="testimonials" element={<AdminTestimonialsPage />} />
                <Route path="blog" element={<AdminBlogPage />} />
                <Route path="blog/new" element={<AdminBlogEditorPage />} />
                <Route path="blog/:id/edit" element={<AdminBlogEditorPage />} />
                <Route path="leads" element={<AdminLeadsPage />} />
              </Route>

              {/* Public marketing site (everything else) */}
              <Route path="/*" element={<PublicSite />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </CurrencyProvider>
  );
}

export default App;
